import { render, staticRenderFns } from "./PageBuilderTextWidget.vue?vue&type=template&id=616b0ed6"
import script from "./PageBuilderTextWidget.vue?vue&type=script&lang=js"
export * from "./PageBuilderTextWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports